module.exports = __webpack_public_path__ + "static/media/info-Icon.290cb681.svg";